import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#0F172A] text-white pt-8 pb-16 px-4 md:pt-12 md:pb-24 overflow-hidden" data-id="element-91">
      {/* Background gradient effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-92">
        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-orange-500/20 rounded-full blur-[100px]" data-id="element-93" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-[100px]" data-id="element-94" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-95">
        <div className="flex justify-center mb-3" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/4m5AbyK5wEzYUJcU8Dg8W8/Diseno_sin_titulo.png" alt="Reseñas de clientes satisfechos" className="w-full max-w-[150px] md:max-w-[180px] h-auto" data-id="element-97" />
        </div>

        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 drop-shadow-sm" data-id="element-98">
          Manual de Emergencias para Mascotas
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-10 font-medium max-w-2xl mx-auto" data-id="element-99">
          Todo listo para actuar cuando cada segundo cuenta.
        </p>

        <div className="max-w-3xl mx-auto mb-10" data-id="element-100">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-101">
            Si tu perro o gato sufre una convulsión, se atraganta o ingiere algo
            tóxico… ¿Sabrías exactamente qué hacer en los primeros minutos?
          </p>
        </div>

        <div className="relative mb-12 flex justify-center group" data-id="element-102">
          <div className="absolute inset-0 bg-orange-500/20 blur-3xl rounded-full transform scale-75 group-hover:scale-100 transition-transform duration-700" data-id="element-103" />
          <img src="https://cdn.magicpatterns.com/uploads/juFDA2PxnawKuD1Ckwj157/PORTADA_EBOOK.png" alt="Portada del Manual de Emergencias para Mascotas" className="relative w-full max-w-[320px] md:max-w-[400px] h-auto shadow-2xl rounded-xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-104" />
        </div>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-105">
          <p className="text-lg md:text-xl text-gray-300 font-medium leading-relaxed" data-id="element-106">
            Este manual fue creado para darte claridad cuando más la necesitás.
            Protocolos paso a paso. Señales de alerta. Qué hacer y qué NO hacer.
          </p>
        </div>

        <div className="flex justify-center" data-id="element-107">
          <a href="#pricing" className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-[#F97316] to-[#EA580C] hover:from-[#EA580C] hover:to-[#C2410C] text-white font-bold py-5 px-10 rounded-full text-xl md:text-2xl transition-all duration-300 shadow-[0_0_40px_-10px_rgba(249,115,22,0.5)] hover:shadow-[0_0_60px_-15px_rgba(249,115,22,0.7)] hover:-translate-y-1" data-id="element-108">
            QUIERO PROTEGER A MI MASCOTA
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-109" />
          </a>
        </div>
      </div>
    </section>;
}